import { AuthController } from '@controllers/auth-controller';
import { CHANGE_HISTORY, PARTNER_ROLES, REPORTING } from '@utils/controller-utils';
import { codeSplit } from 'bernie-core';

export class ChangeHistoryController extends AuthController {
  public pageId = CHANGE_HISTORY;
  public path = '/partner/change-history';
  public routeName = REPORTING;
  public bundles = [];
  public pageTitle = 'controllers.changeHistory';
  public component = codeSplit(
    () => import(/* webpackChunkName: "changeHistory" */ '../../views/partner/change-history'),
  );
  public exact = true;
  public isPartnerView = true;
  public accessRoles = [
    PARTNER_ROLES.ADVERTISER_ADMIN,
    PARTNER_ROLES.ADVERTISER_USER,
    PARTNER_ROLES.ADVERTISER_VIEWER,
    PARTNER_ROLES.ADMIN, //deprecated, to be removed
  ];
  public navIcon = '';
  public tabGroup = 'controllers.reports';
  public groupIcon = 'date_trends';
}
